import type { Client } from '../../../api/client.js';
import type { Argent } from '../types.js';

/** Lignes détaillées (30/10/2026) : routes `facturation.prestations.lister`, `facturation.devis.*`, `facturation.factures.pdf`. */
export interface SectionDetail {
  titre: string;
  lignes: string[];
}

export interface Designation {
  code: string | null;
  intitule: string;
  detail: SectionDetail[];
  catalogueVersion: string | null;
}

export interface Catalogue {
  version: string;
  status: 'a_valider' | 'valide';
  prestations: { code: string; intitule: string; detail: SectionDetail[] }[];
}

export interface Devis {
  id: string;
  dossierId: string;
  phaseScope: 'jusqu_indivision' | 'partage';
  status: 'brouillon' | 'envoye' | 'signe' | 'refuse';
  total: Argent;
  createdAt: string;
  lines: { id: string; position: number; designation: Designation; amount: Argent }[];
}

export interface FactureDetaillee {
  id: string;
  number: string;
  issuedAt: string;
  total: Argent;
  lines?: { label: string; amount: Argent; designation: Designation | null }[];
}

export type LigneNouveauDevis =
  { prestationCode: string; amountCents: number } | { intitule: string; detail: SectionDetail[]; amountCents: number };

export interface NouveauDevis {
  phaseScope: 'jusqu_indivision' | 'partage';
  lignes: LigneNouveauDevis[];
}

export interface SourceDevis {
  catalogue(): Promise<Catalogue>;
  lister(): Promise<Devis[]>;
  creer(d: NouveauDevis): Promise<Devis>;
  pdfDevis(devisId: string): Promise<{ downloadUrl: string }>;
  pdfFacture(factureId: string): Promise<{ downloadUrl: string }>;
}

export const PERMISSION_ECRIRE_DEVIS = 'billing:write:dossier';

export function creerSourceDevis(client: Client, dossierId: string): SourceDevis {
  const parametres = { dossierId };
  return {
    catalogue: () => client.appeler<Catalogue>('facturation.prestations.lister', { parametres }),
    lister: () => client.appeler<Devis[]>('facturation.devis.lister', { parametres }),
    creer: (d) => client.appeler<Devis>('facturation.devis.creer', { parametres, corps: d }),
    pdfDevis: (devisId) => client.appeler<{ downloadUrl: string }>('facturation.devis.pdf', { parametres: { dossierId, devisId } }),
    pdfFacture: (factureId) =>
      client.appeler<{ downloadUrl: string }>('facturation.factures.pdf', { parametres: { dossierId, factureId } }),
  };
}
